import React, { Component } from 'react';
import PrintProvider from 'react-easy-print';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import Card from '../../components/CoPayCard';
import Footnotes from '../../components/Footnotes';

class PrintCard extends Component {
  componentDidMount () {
    setTimeout(() => {
      window.print();
    }, 700);
  }

  render () {
    // let altFootnoteSymbol = false;
    // // bool to show another footnote
    // if (this.props.location.state && this.props.location.state.altFootnoteSymbol) {
    //   altFootnoteSymbol = true;
    // }

    const { cardID, groupID, cardBin, cardPcn } = this.props.match.params;
    const product = new URLSearchParams(this.props.location.search).get('product');

    return (
      <PrintProvider>
        <div className="print-card-container">
          <Header onClick={ () => {} }/>
          <Card selectedProduct={ product } hideButton cardId={ cardID } groupId={ groupID } cardBin={ cardBin } cardPcn={ cardPcn } />
          <Footnotes footnotes={ [2.5, 3, 4] }/>
        </div>
      </PrintProvider>
    );
  }
}

export default withRouter(PrintCard);
